import { render, staticRenderFns } from "./ChangePasswordUser.vue?vue&type=template&id=75a0fa46&scoped=true&"
import script from "./ChangePasswordUser.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a0fa46",
  null
  
)

export default component.exports